<div *ngIf="showUsersnapWidget"
    class="fixed inset-0 flex items-center justify-center z-40" role="dialog" aria-modal="true">
    <div class="flex items-center justify-center">
        <div class="w-full h-full flex flex-col items-center justify-center">
            <div class="fixed inset-0 z-30 flex items-center justify-center" aria-modal="true" role="dialog">
                <div
                    id="usersnap-container"
                    class="relative bg-white rounded-md shadow-custom-2 p-6 flex flex-col items-center gap-4"
                >
                    <div id="widgetContainer"></div>
                    <div class="w-full pt-4 rounded-b-md bg-white flex items-center justify-end gap-3">
                        <button 
                            class="px-4 py-2 w-20 rounded-md border border-nside-gray-200 oswald-font text-nside-gray-200"
                            (click)="$event.preventDefault(); closeUsersnapWidget()"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>